
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/auth');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-400 via-green-500 to-green-600 flex flex-col items-center justify-center relative overflow-hidden">
      {/* خلفية متحركة */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 right-10 w-16 h-16 bg-white rounded-full animate-bounce"></div>
        <div className="absolute bottom-32 left-8 w-12 h-12 bg-white rounded-full animate-pulse"></div>
        <div className="absolute top-1/2 left-1/4 w-8 h-8 bg-white rounded-full animate-ping"></div>
      </div>

      {/* الشعار والعنوان */}
      <div className="text-center z-10">
        <div className="mb-8 animate-pulse">
          <div className="w-24 h-24 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-lg">
            <i className="ri-shopping-cart-2-fill text-4xl text-green-500"></i>
          </div>
        </div>
        
        <h1 className="text-4xl font-bold text-white mb-2" style={{fontFamily: 'Tajawal, sans-serif'}}>
          سلة البقالة
        </h1>
        <p className="text-white/80 text-lg">
          تسوق طازج، توصيل سريع
        </p>
      </div>

      {/* مؤشر التحميل */}
      <div className="absolute bottom-20 flex space-x-2">
        <div className="w-3 h-3 bg-white rounded-full animate-bounce"></div>
        <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
        <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
      </div>
    </div>
  );
}
